import cx from 'classnames';
import * as React from 'react';

import './styles/LoadingIndicator.scss';

// TODO
// * Reconcile with other loaders
// * Reconsider `align` default
// * Reduce # of sizes

export enum LoadingIndicatorSizeEnum {
  large = 'large',
  medium = 'medium',
  small = 'small',
  xsmall = 'xsmall',
  default = 'medium',
}

export type LoadingIndicatorSize = keyof typeof LoadingIndicatorSizeEnum | LoadingIndicatorSizeEnum;

export enum LoadingIndicatorColorEnum {
  apple = 'apple',
  graphite = 'graphite',
  percussion = 'percussion',
  whiteout = 'whiteout',
  default = 'graphite',
}

export type LoadingIndicatorColor =
  | keyof typeof LoadingIndicatorColorEnum
  | LoadingIndicatorColorEnum;

export type LoadingIndicatorAlign = 'left' | 'center' | 'right';

export type Props = {
  align?: LoadingIndicatorAlign;
  className?: string;
  color?: LoadingIndicatorColor;
  // Placehold height for content to be loaded
  height?: number;
  size?: LoadingIndicatorSize;
};

export default class LoadingIndicator extends React.Component<Props> {
  render() {
    const {
      align,
      className,
      height,
      color: specificColor,
      size: specificSize,
      ...others
    } = this.props;
    const color = specificColor ?? 'graphite';
    const size = specificSize ?? 'medium';

    const dot = <div className="LoadingIndicator-dot" />;

    return (
      <div
        aria-label="Loading indicator"
        data-testid="loading-indicator"
        role="img"
        style={{ minHeight: height || undefined }}
        className={cx(
          'LoadingIndicator',
          align && `LoadingIndicator--${align}`,
          color && `LoadingIndicator--${color}`,
          height ? 'LoadingIndicator--height' : null,
          size && `LoadingIndicator--${size}`,
          className
        )}
        {...others}
      >
        {dot}
        {dot}
        {dot}
      </div>
    );
  }
}
